var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.openPlanChangeFail
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "modal fade show",
            staticStyle: { display: "block" },
            attrs: {
              id: "go-modal-login-move",
              tabindex: "-1",
              "aria-hidden": "true",
            },
          },
          [
            _c("div", { staticClass: "modal-dialog go-modal-plan" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn go-btn-icon close",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: { click: _vm.close },
                    },
                    [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "go-block-header" }, [
                    _c("div", { staticClass: "go-msg-icon" }, [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("p", { staticClass: "go-text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.mapTypeChangePlanAndMessage1[_vm.typeChangePlan]
                          )
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "go-block-body" }, [
                    _c("span", {
                      staticClass: "go-text-sub",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.mapTypeChangePlanAndMessage2[_vm.typeChangePlan]
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _vm.typeChangePlan !== _vm.TYPE_CHANGE_PLAN.USE_SAME &&
                    _vm.typeChangePlan !==
                      _vm.TYPE_CHANGE_PLAN.CHANGE_ALREADY_SCHEDULE
                      ? _c("div", { staticClass: "bg-gray" }, [
                          _c("div", { staticClass: "go-msg-text" }, [
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("payment.fail.errorCode", {
                                    errorCode: _vm.errorCode,
                                    errorMsg:
                                      _vm.mapErrorCodeAndMsg[_vm.errorCode],
                                  })
                                ),
                              },
                            }),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c("div", { staticClass: "go-block-between" }, [
                    _vm.typeChangePlan ===
                    _vm.TYPE_CHANGE_PLAN.CHANGE_ALREADY_SCHEDULE
                      ? _c(
                          "button",
                          {
                            staticClass: "btn go-btn-default",
                            attrs: { type: "button", "data-dismiss": "modal" },
                            on: { click: _vm.close },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("payment.button.ok")) +
                                "\n            "
                            ),
                          ]
                        )
                      : _c(
                          "button",
                          {
                            staticClass: "btn go-btn-default",
                            attrs: { type: "button", "data-dismiss": "modal" },
                            on: { click: _vm.close },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("payment.button.close")) +
                                "\n            "
                            ),
                          ]
                        ),
                  ]),
                ]),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "modal-backdrop fade show" }),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "go-icon-wrap fail" }, [
      _c("i", { staticClass: "go-icon-54 go-icon-alert-circle" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }